import { render, staticRenderFns } from "./navbar_staff.vue?vue&type=template&id=4d1e9b47&scoped=true"
import script from "./navbar_staff.vue?vue&type=script&lang=js"
export * from "./navbar_staff.vue?vue&type=script&lang=js"
import style0 from "./navbar_staff.vue?vue&type=style&index=0&id=4d1e9b47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1e9b47",
  null
  
)

export default component.exports